import React from "react"
import PropTypes from "prop-types"

const FormSectionTitle = ({ title, subtitle, size = "small" }) => {
  const titleSize = size === "lg" ? "text-3xl" : "text-xl"
  const subtitleSize = size === "lg" ? "text-lg" : "text-md"
  return (
    <>
      {title && (
        <h2 className={`${titleSize} font-semibold font-cairo m-0`}>{title}</h2>
      )}
      {subtitle && (
        <h3 className={`${subtitleSize} font-semibold font-cairo m-0`}>
          {subtitle}
        </h3>
      )}
    </>
  )
}

export default FormSectionTitle

FormSectionTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  size: PropTypes.oneOf(["lg", "sm"]),
}
